import { EMPTY_MODULE_API_INFO, EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { createAccount, hideAddEditAccountModal, updateAccount } from "../actions";
import { localStateSelector, makeAccountDetailSelector, makeItemsSelector } from "../selectors";
import { type MemberWallet } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: EMPTY_MODULE_API_INFO,
  error: null,
  isVisible: false,
  status: "None",
  accounts: [],
  detail: null,
  currencies: []
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const itemsSelector = makeItemsSelector();
  const detailSelector = makeAccountDetailSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.isAddEditAccountModalVisible) return INVISIBLE_PROPS;

    return {
      ...props,
      accounts: itemsSelector(state, props),
      apiInfo: apiInfoSelector(state, props),
      currencies: localState.currencies,
      detail: detailSelector(state, props),
      error: localState.error,
      isVisible: true,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(hideAddEditAccountModal(getEntityRef(props))),
  onSubmit: (data: MemberWallet.View.Account, isAdd: boolean) =>
    dispatch(isAdd ? createAccount(getEntityRef(props), data) : updateAccount(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
